import React from 'react'
import TableHead from '@material-ui/core/TableHead'
import tsodlogo from './images/logo.png'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import {Link} from 'react-router-dom'
const Header=()=>
{
    return(
        <>
        <TableHead>
            <TableRow>
     
           <TableCell align="center" colSpan="4" >
                 <img src={tsodlogo} width='350' height='auto' alt='Logo' />
                </TableCell>
        
            </TableRow>
        </TableHead>
        <TableRow>
            <TableCell colSpan="4">
            <nav>
          <ul>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/view'>View</Link></li>
            

          </ul>
        </nav>

            </TableCell>
        </TableRow>

        </>
    )
}
export default Header